/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSetMealIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-set-meal"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.33 15.32Q2.2 15.32 1.44 14.56Q0.68 13.8 0.68 12.68L0.68 4.33Q0.68 3.2 1.44 2.44Q2.2 1.68 3.33 1.68L20.68 1.68Q21.8 1.68 22.56 2.44Q23.32 3.2 23.32 4.33L23.32 12.68Q23.32 13.8 22.56 14.56Q21.8 15.32 20.68 15.32ZM20.3 17.6L3.83 18.45Q3.5 18.48 3.27 18.27Q3.05 18.07 3.02 17.75Q3 17.43 3.21 17.2Q3.42 16.98 3.75 16.95L20.23 16.1Q20.55 16.07 20.77 16.27Q21 16.48 21.02 16.8Q21.05 17.13 20.84 17.35Q20.63 17.57 20.3 17.6ZM20.25 20.98L3.75 20.98Q3.42 20.98 3.21 20.76Q3 20.55 3 20.23Q3 19.9 3.21 19.69Q3.42 19.48 3.75 19.48L20.25 19.48Q20.57 19.48 20.79 19.69Q21 19.9 21 20.23Q21 20.55 20.79 20.76Q20.57 20.98 20.25 20.98ZM10.45 11.47Q12.1 11.47 13.63 10.85Q15.15 10.22 16.35 9.07Q16.57 9.9 17.25 10.41Q17.93 10.93 18.8 11.05Q19.15 11.1 19.41 10.95Q19.68 10.8 19.68 10.4L19.68 6.6Q19.68 6.2 19.4 6.05Q19.13 5.9 18.77 5.95Q17.9 6.08 17.23 6.59Q16.55 7.1 16.35 7.95Q15.13 6.83 13.61 6.17Q12.1 5.53 10.45 5.53Q8.65 5.53 7.15 6.13Q5.65 6.72 4.45 8.07Q4.4 8.13 4.3 8.5Q4.3 8.55 4.45 8.93Q5.65 10.28 7.15 10.88Q8.65 11.47 10.45 11.47Z" fill={color} />
    </svg>
  );
}
